export const miscRoutes = (apiBase) => ({
  saveAnswers: `${apiBase}/guardarRespuesta`,
  dataGraficas: (ident, tipoId) => `${apiBase}/datosGraficas?ident=${ident}&tipo_id=${tipoId}`,
  guardarFechaGestacion: `${apiBase}/cohorte/updateFechaG`,
  cargarResultado: `${apiBase}/UploadResult`,
  consecutivo: `${apiBase}/consecutivo`,
  getcons: (estado) => `${apiBase}/consecutives?estado=${estado}`,
  getConsById: (id) => `${apiBase}/consecutives-by-id?id=${id}`,
  saveCons: `${apiBase}/consecutives`,
  ComplementoCons: (consecutivo, Identificacion) => `${apiBase}/complementoConsecutivo?consecutivo=${consecutivo}&Identificacion=${Identificacion}`,
  saveResult: `${apiBase}/guardarResultado`,
  getDepartment: `${apiBase}/departments`,
  getTown: (idDep) => `${apiBase}/municipalities?departamento=${idDep}`,
  getPrestadores: (idDep, idMuni, tipo, ese, active) =>
    `${apiBase}/prestadores?id_dep=${idDep}&id_muni=${idMuni}&tipo=${tipo}&ese=${ese}&estado=${active}`,
});
